var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_1_249)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_249",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M48 0H0V48H48V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_249)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 21C3 16.8579 3 20.25 3 18H45C45 21.75 45 16.8579 45 21V22.5C45 24.9854 42.9854 27 40.5 27H32.4854C31.2918 27 30.1472 27.4742 29.3032 28.3181L25.1186 32.5028C23.7489 33.8724 23.4095 35.9648 24.2757 37.6973L25.3416 39.8292C25.5741 40.2942 25.5493 40.8463 25.2759 41.2885C25.0026 41.7307 24.5199 42 24 42H10.5C6.35787 42 3 38.6421 3 34.5V21Z",
    fill: "url(#paint0_linear_1_249)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7716 39.4086C34.3398 40.0113 34.3398 40.9887 33.7716 41.5914C33.2032 42.1941 32.2818 42.1941 31.7136 41.5914L27.4708 37.0914C26.9026 36.4887 26.9026 35.5113 27.4708 34.9086L31.7136 30.4086C32.2818 29.8057 33.2032 29.8057 33.7714 30.4086C34.3398 31.0113 34.3398 31.9887 33.7716 32.5914L30.5578 36L33.7716 39.4086ZM37.7136 32.5914C37.1452 31.9887 37.1452 31.0114 37.7136 30.4086C38.2818 29.8059 39.2032 29.8059 39.7716 30.4086L44.0142 34.9086C44.5824 35.5114 44.5824 36.4887 44.0142 37.0914L39.7716 41.5914C39.2032 42.1942 38.2818 42.1942 37.7136 41.5914C37.1452 40.9887 37.1452 40.0113 37.7136 39.4086L40.9272 36L37.7136 32.5914Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 6C6.35787 6 3 9.35787 3 13.5V15H45V13.5C45 9.35787 41.6421 6 37.5 6H10.5ZM9 12C9.82842 12 10.5 11.3284 10.5 10.5C10.5 9.67158 9.82842 9 9 9C8.17158 9 7.5 9.67158 7.5 10.5C7.5 11.3284 8.17158 12 9 12ZM13.5 12C14.3284 12 15 11.3284 15 10.5C15 9.67158 14.3284 9 13.5 9C12.6716 9 12 9.67158 12 10.5C12 11.3284 12.6716 12 13.5 12ZM19.5 10.5C19.5 11.3284 18.8285 12 18 12C17.1715 12 16.5 11.3284 16.5 10.5C16.5 9.67158 17.1715 9 18 9C18.8285 9 19.5 9.67158 19.5 10.5Z",
    fill: "url(#paint1_linear_1_249)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_249",
    x1: 33.122,
    y1: 23.4089,
    x2: 24.5311,
    y2: 42.7861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DE8EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#9DE8EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.490049,
    stopColor: "#FA7C0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8CED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_249",
    x1: 33.122,
    y1: 8.02833,
    x2: 31.7153,
    y2: 16.4892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DE8EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#9DE8EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.490049,
    stopColor: "#FA7C0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8CED"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.e98d95b3a3fd1001d29a2c056b13cd59.svg";
export { ForwardRef as ReactComponent };